export const downloadAsLink = (url: string, filename: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.target = "_blank"; // Open link in a new tab
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadAsBlob = async (url: string, filename: string) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Download failed with status ${response.status}`);
  const blob = await response.blob();

  // Object URLs avoid the data-URI size limits that make large downloads fail silently
  const blobUrl = window.URL.createObjectURL(blob);
  downloadAsLink(blobUrl, filename);
  window.URL.revokeObjectURL(blobUrl);
};

export const downloadAsFetchLink = (url: string, filename: string) => {
  // Fetch the file data using a GET request
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      // Create an object URL for the blob object
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a new anchor element
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;

      // Append the link to the body, click it, and remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Release the object URL
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch((error) => console.error("Error downloading file:", error));
};
